module.exports = __webpack_public_path__ + "static/media/tonmei.dd06d5e7.jpg";